<script setup lang="ts">
import { useI18n } from '@/app/i18n'
import AppModal from '@/shared/ui/AppModal.vue'
import AppPassword from '@/shared/ui/AppPassword.vue'

import type { AccountSwitch } from './useAccountSwitch'

/**
 * "Confirm your identity": the password step of an account switch (`useAccountSwitch`). The switcher's refs are taken
 * once: the prop is the parent's own composable instance and never changes (binding them through the prop in the
 * template would be a prop mutation, vue/no-mutating-props).
 */
const props = defineProps<{ switcher: AccountSwitch }>()
const { t } = useI18n()
const { confirming, password, error, submit } = props.switcher
</script>

<template>
  <AppModal
    v-model:visible="confirming"
    :title="t('shell.modal.confirmIdentity.title.page')"
    ok-only
    :ok-title="t('common.action.submit')"
    :ok-action="submit"
  >
    <p class="mb-4">{{ t('shell.modal.confirmIdentity.hint.body') }}</p>
    <label for="account-password" class="mb-1 block text-[0.857rem] text-heading is-required">
      {{ t('shell.modal.confirmIdentity.field.password') }}
    </label>
    <AppPassword
      id="account-password"
      v-model="password"
      :invalid="Boolean(error)"
      :placeholder="t('shell.modal.confirmIdentity.placeholder.password')"
    />
    <small v-if="error" class="mt-1 block text-danger" role="alert">{{ error }}</small>
  </AppModal>
</template>
